export function useColumnWidth(cards: number, columnsOnMobile: string) {
    const phoneSmall = computed(() => columnsOnMobile === '2' ? 2 : 1); 
    const phone = 2;
    const phablet = computed(() => cards === 4 ? 2 : 3);
    const laptop = computed(() => {
        if (cards === 4 || cards === 3) {
            return 4;
        }
        return 3;
    });
    const desktop = computed(() => {
        if (cards === 1) {
            return 5;
        }
        if (cards === 2) {
            return 4;
        }
        return 6;
    });
    return {
        phoneSmall,
        phone,
        phablet,
        laptop,
        desktop,
    }
}
